import { Alert, IconButton, Stack } from "@mui/material"
import { useEffect } from "react"
import { useState } from "react"
import { Delete, Download, PictureAsPdf } from "@mui/icons-material"
import { LoadingButton } from "@mui/lab"
import { txt } from "../../services/translation"

export default function PDF({id, value, onChange, width, height, loading, error}){

    const [err, setErr] = useState(false)

    const [max] = useState(100000000)

    useEffect(() => {

        setErr(error)

    }, [error])


    const handleFile = file => {

        if (file.type !== 'application/pdf') {

            return setErr(txt('errorFileNotPDF'));

        } else if (file.size > max) {

            return setErr(txt('errorPDFTooLarge'));
        }

        setErr(false);

        file.url = URL.createObjectURL(file);

        return onChange(file);
    }

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = value?.url;
        link.setAttribute('download', id + '.pdf');
        document.body.appendChild(link);
        link.click();
    }

    const handleChange = e => {
        let files = e.target.files;
        return (files && files.length) ? handleFile(files[0]) : false;
    }

    const handleDrop = e => {
        e.preventDefault();
        let files = e.dataTransfer.files;
        return (files && files.length) ? handleFile(files[0]) : false;
    }

    const handleDrag = e => {
        e.preventDefault();
    }

    const handleDelete = () => {
        document.getElementById(id).value = '';
        return onChange(null);
    }

    return <Stack spacing={1}>

        <Stack direction='row' justifyContent='space-between' spacing={1}>

            <LoadingButton 
                startIcon={<PictureAsPdf />} 
                variant='outlined'
                onClick={() => document.getElementById(id).click()}
                loading={loading}
                sx={{flex: 1, borderStyle: 'dashed', minHeight: 80}}
                onDrop={handleDrop}
                onDragOver={handleDrag}
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                size='large'
            >
                {txt('dropPdf')}
            </LoadingButton>

            {value?.url && 
                <Stack direction='row'>
                    <IconButton onClick={handleDownload}>
                        <Download />
                    </IconButton>

                    <IconButton onClick={handleDelete}>
                        <Delete />
                    </IconButton>
                </Stack>
            }

        </Stack>

        {err && 
            <Alert severity='error'>{err}</Alert>
        }

        <input
            id={id} 
            type="file" 
            style={{display: 'none'}}
            onChange={handleChange}
            accept="application/pdf"
        />

        {value?.url && 
            <iframe
                title="PDF"
                src={value?.url}
                width={width || '100%'}
                height={height || 600}
                style={{border: 'solid 1px lightgrey'}}
                frameBorder={0}
            >
            </iframe>
        }

    </Stack>
}